import AddIcon from '@mui/icons-material/Add';
import PublicIcon from '@mui/icons-material/Public';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import React, {JSX} from 'react';
import { SupportSlotDefinitionModel } from '../../../model/support/slot/support-slot-definition.model';

const days = ["Pn", "Wt", "Śr", "Cz", "Pt", "So", "Nd"];

type Props = {
  slots: SupportSlotDefinitionModel[];
  onAddSlotPressed?: (weekday: number) => void;
  onSlotPressed: (slot: SupportSlotDefinitionModel) => void
  buildSlotIcon?: (slotDefinitionId: string) => JSX.Element
  height?: number
}

export const SupportSlotWeekDayComponent = ({ slots, onAddSlotPressed, onSlotPressed, height, buildSlotIcon }: Props) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(7, 1fr)"
      gap={2}
      sx={{ minHeight: `${height ?? 300}px` }}
    >
      {days.map((day, i) => {
        const weekday = i === 6 ? 0 : i + 1;

        const daySlots = slots
          .filter((s) => s.weekday === weekday)
          .sort((a, b) => a.startTime.localeCompare(b.startTime));

        return (
          <Paper
            key={i}
            variant="outlined"
            sx={{
              p: 1.5,
              borderRadius: 2,
              textAlign: "center",
              backgroundColor: "background.paper",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: height ?? 350,
            }}
          >
            <Typography
              variant="subtitle2"
              fontWeight="bold"
              color="text.secondary"
              mb={1}
            >
              {day}
            </Typography>

            <Box width="100%" flex={1} overflow="auto">
              <Stack spacing={1} sx={{ pb: 1 }}>
                {daySlots.map((slot, idx) => (
                  <Chip
                    key={idx}
                    icon={buildSlotIcon ? buildSlotIcon(slot.id) : <PublicIcon fontSize="small" />}
                    label={`${slot.startTime}–${slot.endTime}`}
                    color={"primary"}
                    size="small"
                    sx={{
                      width: "100%",
                      borderRadius: 2,
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": { opacity: 0.9 },
                    }}
                    onClick={() => onSlotPressed(slot)}
                  />
                ))}
                {daySlots.length === 0 && (
                  <Typography variant="caption" color="text.disabled">
                    Brak slotów
                  </Typography>
                )}
              </Stack>
            </Box>
            {
              onAddSlotPressed
                ?  <Button
                  variant="outlined"
                  size="small"
                  startIcon={<AddIcon />}
                  fullWidth
                  sx={{
                    mt: 'auto',
                    py: 0.5,
                    px: 1.5,
                    fontSize: '0.75rem'
                  }}
                  onClick={() => onAddSlotPressed(weekday)}
                >
                  Dodaj slot
                </Button> : <></>
            }
          </Paper>
        );
      })}
    </Box>
  );
};
